import type { IsEmriDurumu, OdemeDurumu } from '@nero/shared';
import { IS_EMRI_DURUM_ADI, ODEME_DURUM_ADI } from '@nero/shared';
import { Rozet, type RozetTonu } from '../../bilesenler/temel.js';

const DURUM_TONU: Record<IsEmriDurumu, RozetTonu> = {
  Bekliyor: 'uyari',
  Devam: 'bilgi',
  Tamamlandi: 'olumlu',
  Teslim: 'notr',
  Iptal: 'kritik',
};

export function DurumRozeti({ durum }: { durum: IsEmriDurumu }) {
  return <Rozet ton={DURUM_TONU[durum]}>{IS_EMRI_DURUM_ADI[durum]}</Rozet>;
}

const ODEME_TONU: Record<OdemeDurumu, RozetTonu> = {
  Odenmedi: 'kritik',
  Kismi: 'uyari',
  Odendi: 'olumlu',
};

export function OdemeRozeti({ durum }: { durum: OdemeDurumu }) {
  return <Rozet ton={ODEME_TONU[durum]}>{ODEME_DURUM_ADI[durum]}</Rozet>;
}
